import * as tslib_1 from "tslib";
import { EventBase } from "../events/EventBase";
var URLLoaderEvent = (function (_super) {
    tslib_1.__extends(URLLoaderEvent, _super);
    function URLLoaderEvent(type, urlLoader) {
        var _this = _super.call(this, type) || this;
        _this._urlLoader = urlLoader;
        return _this;
    }
    Object.defineProperty(URLLoaderEvent.prototype, "urlLoader", {
        /**
         *
         */
        get: function () {
            return this._urlLoader;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     */
    URLLoaderEvent.prototype.clone = function () {
        return new URLLoaderEvent(this.type, this._urlLoader);
    };
    return URLLoaderEvent;
}(EventBase));
export { URLLoaderEvent };
URLLoaderEvent.HTTP_STATUS = "httpStatus";
URLLoaderEvent.LOAD_ERROR = "loadError";
URLLoaderEvent.LOAD_PROGRESS = "loadProgress";
URLLoaderEvent.LOAD_START = "loadStart";
URLLoaderEvent.LOAD_COMPLETE = "loadComplete";



// WEBPACK FOOTER //
// ../dist/lib/events/URLLoaderEvent.js